import { useEffect, useMemo } from "react"
import { StyleObject } from "styletron-react"
import { colors, fonts, frames } from "../Styles"

import AttentionListItem from "./AttentionComponents/attentionListItem"
import { useAppSelector } from "../Store"
import { Graph_QL } from "../Services"
import { useSystem } from "../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem"
interface StatusList_Props {
    focus_view?: boolean
    overrides?:{
        gridArea?: string
    }
  }

export default function StatusList({ focus_view=false, overrides }: StatusList_Props) {
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const { call: getSystemCall, data: systemsState } = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
  }, [])
  
  const states = useMemo(() => {
    return systemsState[domain]?.data || []
  }, [domain, systemsState]);

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign({} as StyleObject, overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {} )
  }, [overrides])
  
  return (
    <frames.SystemMenu $style={_Root}>
      {states.length === 0 ? (
        <p style={{ ...fonts.fontsize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "center" }}>No States Found</p> // TODO Translate
      ) : (
        <frames.SystemList $focusView={focus_view ?? false}>
          {states.map((system) => (
            <AttentionListItem focus_view={focus_view} key={system.system_id} systemNo={system.system_id} />
          ))}
        </frames.SystemList>
      )}
    </frames.SystemMenu>
  )
}